import { Injectable } from '@angular/core';
import { ReplaySubject, Observable } from 'rxjs';
import { ElementSize } from '../../directives/element-size';

@Injectable({
  providedIn: 'root'
})
export class ContentSizeService {
  constructor() {}

  private _contentSize$ = new ReplaySubject<ElementSize>(1);
  public get contentSize$() {
    return this._contentSize$ as Observable<ElementSize>;
  }
}
